// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
export class Embeddings extends APIResource {
    /**
     * List available embedding models using the asynchronous implementation for
     * improved performance.
     *
     * Returns EmbeddingModel format which extends EmbeddingConfig with additional
     * metadata fields. Legacy EmbeddingConfig fields are marked as deprecated but
     * still available for backward compatibility.
     */
    list(options) {
        return this._client.get('/v1/models/embedding', options);
    }
}
//# sourceMappingURL=embeddings.mjs.map